import AddToCartBase from "./add_to_cart_base";

export default class AddToCartBundleSimplified extends AddToCartBase {
  initialize() {
    this.url = this.element.dataset.cartUrl;
    this.plusButton.addEventListener("click", () => {
      this.postUpdatedQuantity();
    });

    this.element.addEventListener("product-quantity-updated", (e) => {
      this.element.classList.add("has-quantity");
      this.addToCartToggle.innerHTML = this.quantityElement.value;
      this.quantityElement.value = parseInt(this.quantityElement.value) + 1;
    });
  }
}
